/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type FirmSummaryDefinition = {
  readonly id?: number;
  name: string;
  visibility?: FirmSummaryDefinition.visibility;
  spreadsheet_definition?: any;
  view_kind?: FirmSummaryDefinition.view_kind;
  dashboard_definition?: any;
  readonly created_by?: number | null;
  readonly created_at?: string;
  readonly updated_at?: string;
  cloned_from?: number | null;
  readonly firm?: number;
  readonly page_type?: string;
};
export namespace FirmSummaryDefinition {
  export enum visibility {
    USER = 'user',
    FIRM = 'firm',
    SCALAR = 'scalar',
    PUBLIC = 'public',
  }
  export enum view_kind {
    SPREADSHEET = 'spreadsheet',
    DASHBOARD = 'dashboard',
  }
}
